import { render } from "./employee-justin.vue?vue&type=template&id=5fb85b42"
import script from "./employee-justin.vue?vue&type=script&lang=js"
export * from "./employee-justin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__